module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kPTZi"))).then(() => parcelRequire('ikE14'));